import { Slot } from './slot'

export class Commercial {
    slot: Slot
    minutes: number
    uom: number
    unit: number
    unitUoM: string
    cost: number
    cgstrate: number
    sgstrate: number
    gstrate: number
    cgstamount: number
    sgstamount: number
    gstamount: number
    nettCost: number
    discountPercentage?: number
    discountAmount?: number
    taxableAmount?: number
    distributionCharge?: number

    constructor(slot: Slot,
        minutes: number,
        uom: number,
        unit: number,
        unitUoM: string,
        cost: number,
        cgstrate: number,
        sgstrate: number,
        gstrate: number,
        cgstamount: number,
        sgstamount: number,
        gstamount: number,
        nettCost: number) {
            this.slot = slot
            this.minutes = minutes
            this.uom = uom
            this.unit = unit
            this.unitUoM = unitUoM
            this.cost = cost
            this.cgstrate = cgstrate
            this.sgstrate = sgstrate
            this.gstrate = gstrate
            this.cgstamount = cgstamount
            this.sgstamount = sgstamount
            this.gstamount = gstamount
            this.nettCost = nettCost
    }
}